export { default } from './NewPaymentMean.container';
